import { useEffect, useState } from 'react';
import { getUserAssessment } from '../../../api/assessment.api';
import moment from 'moment-jalaali';

const AssessmentTab = ({ userId }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    loadAssessment();
  }, []);

  const loadAssessment = async () => {
    try {
      const res = await getUserAssessment(userId);

      console.log('RAW RESPONSE:', res);

      // اگر API شکل زیر باشد: { data: { height: ... } }
      const assessment = res.data?.data ? res.data.data : res.data;

      console.log('FINAL ASSESSMENT:', assessment);

      setData(assessment);
    } catch (err) {
      console.error('Error loading assessment:', err);
    }
  };

  if (!data) return <p>در حال بارگذاری اطلاعات اولیه...</p>;

  // Helper برای نمایش مقدار یا خط تیره
  const show = (value) => (value === 0 || value ? value : '-');
  const healthItems = [
    ['بیماری یا وضعیت پزشکی خاص', data.medicalConditions || data.illness],
    ['داروها و مکمل‌های مصرفی', data.medications || data.medication],
    ['درد، آسیب یا محدودیت حرکتی', data.physicalLimitations || data.pain],
    ['معلولیت یا شرایط جسمی ویژه', data.disabilities],
    ['حساسیت یا عدم تحمل غذایی', data.foodAllergies],
    ['پرهیزها و ملاحظات غذایی', data.dietaryRestrictions],
    ['توضیحات تکمیلی سلامت', data.healthNotes],
  ];
  const hasHealthDetails = healthItems.some(([, value]) => Boolean(value));

  return (
    <div className="p-3 border rounded bg-white">
      <h5 className="mb-3">اطلاعات اولیه کاربر</h5>

      <div className="row mb-4">
        <div className="col-md-3">
          <strong>قد:</strong> {show(data.height)}
        </div>
        <div className="col-md-3">
          <strong>سن:</strong> {show(data.age)}
        </div>
        <div className="col-md-3">
          <strong>جنسیت:</strong> {show(data.gender)}
        </div>
        <div className="col-md-3">
          <strong>تجربه ورزشی:</strong> {show(data.trainingExperience)}
        </div>
      </div>

      <h6 className="mt-3">اهداف و فعالیت</h6>
      <div className="border p-3 rounded mb-3 bg-light">
        <div>
          <strong>هدف اصلی:</strong> {show(data.mainGoal)}
        </div>
        <div>
          <strong>سطح فعالیت:</strong> {show(data.activityLevel)}
        </div>
        <div>
          <strong>تعداد روزهای تمرین:</strong> {show(data.trainingDays)}
        </div>
      </div>

      <hr />

      <h6 className="mt-3">سلامت، محدودیت‌ها و تغذیه</h6>
      <div className="border p-3 rounded mb-3" style={{ background: '#fff8f4' }}>
        {!hasHealthDetails ? (
          <div className="text-muted">کاربر مورد خاصی اعلام نکرده است.</div>
        ) : (
          <div className="row g-3">
            {healthItems.map(([label, value]) => value ? (
              <div className="col-12 col-md-6" key={label}>
                <strong className="d-block mb-1">{label}</strong>
                <div style={{ whiteSpace: 'pre-wrap', lineHeight: 1.9 }}>{value}</div>
              </div>
            ) : null)}
          </div>
        )}
      </div>

      <hr />

      <div className="text-muted" style={{ fontSize: '0.9rem' }}>
        تاریخ ثبت:{' '}
        {data.createdAt ? moment(data.createdAt).format('jYYYY/jMM/jDD') : '-'}
      </div>
    </div>
  );
};

export default AssessmentTab;
